import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseOrgDefaultClassificationLevelIdQuery, {
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables,
} from '../hooks/__generated__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadOrgDefaultClassificationLevelIdQuery(): Promise<{
	data: useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables
	>({
		query: UseOrgDefaultClassificationLevelIdQuery,
	});
}
